import { CustomModal } from "../../components/CustomModal";
import KindlyNote from "../../components/Accounts/KindlyNote";
import { fipayTagData } from "./data";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store/rootReducer";
import { setSecondModalOpen } from "../../store/accountsModal";
import { Formik } from "formik";
import * as Yup from "yup";
import Button from "../../components/Button/Button";
import InputContainer from "../../components/Accounts/InputContainer";
import { useMutation } from "@apollo/client";
import { createTag } from "../../graphql/mutations/accounts";
import { setUserData } from "../../store/user";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { setLoading } from "../../store/loadingSpinner";

const CreateFipayTag = () => {
  const id = useSelector((state: RootState) => state.user?.user.id);
  const [createTagMutation, { loading, error, data }] = useMutation(createTag);
  const dispatch = useDispatch();
  const { secondModalOpen } = useSelector(
    (state: RootState) => state.accountsModal
  );
  const navigate = useNavigate();
  const handleClose = () => {
    dispatch(setSecondModalOpen(false));
  };

  const handleCreateTag = async (values: { tag: string }) => {
    handleClose();
    dispatch(setLoading(true));
    const { tag } = values;
    try {
      const { data } = await createTagMutation({
        variables: {
          input: {
            tag: tag,
            // userId: id,
          },
        },
      });
      if (data && data.createTag) {
        dispatch(setUserData({ tag: data.createTag.tag }));
        navigate("/dashboard/accounts/payment-details");
        toast.success("You've successfully created your fipay tag", {
          style: {
            background: "#DEF1DE",
            color: "#388233",
          },
        });
      } else {
        console.error("Failed to create tag or invalid response.");
      }
    } catch (error) {
      console.error("Error creating tag:", error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      <CustomModal
        open={secondModalOpen}
        onClose={handleClose}
        header={{
          title: "Create Fipay Tag",
          subtitle:
            "Create your fipay tag to receive money from other fipay users",
        }}
      >
        <Formik
          initialValues={{ tag: "" }}
          validationSchema={Yup.object({
            tag: Yup.string()
              .min(4, "Must be 4 characters")
              .required("Required")
              .matches(
                /^[a-z0-9_]+$/,
                "Only letters, numbers, and underscores allowed"
              ),
          })}
          onSubmit={(values, { setSubmitting }) => {
            handleCreateTag(values);

            setSubmitting(false);
          }}
        >
          {(formik) => (
            <form onSubmit={formik.handleSubmit}>
              <InputContainer
                name="tag"
                label="Fipay Tag"
                type="text"
                placeholder="@"
                hasPrefix
                value={formik.values.tag}
                onChange={formik.handleChange}
                width={"100%"}
                error={formik.touched.tag && formik.errors.tag}
              />
              {fipayTagData.map((data) => (
                <KindlyNote
                  title={"KINDLY NOTE:"}
                  list={[data.item1, data.item2]}
                />
              ))}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "1rem",
                }}
              >
                <Button
                  id={""}
                  type="submit"
                  onClick={handleClose}
                  padding={"10px 30px"}
                  title={"Cancel"}
                  border="10px"
                  cancel
                />
                <Button
                  id={""}
                  type="submit"
                  padding={"10px 30px"}
                  title={"Create Fipay Tag"}
                  border="10px"
                  green
                  disabled={!formik.isValid || !formik.dirty}
                />
              </div>
            </form>
          )}
        </Formik>
      </CustomModal>
    </>
  );
};

export default CreateFipayTag;
